<template>
	<div>
		<el-dialog :title="$t('parent_index.order')" data-title="订单" width="1400px" :close-on-click-modal="false" :visible="isdialog" :before-close="guanbitanchu">
			<el-table :data="list" border size="mini">
				<el-table-column prop="order_id" align="center" :label="$t('order.no')"></el-table-column>
				<el-table-column prop="create_time" align="center" :label="$t('order.create_time')">
				<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}} {{getTime_us(scope.row.create_time,'hh:ii')}}</template>
				</el-table-column>
				<el-table-column prop="user_info.name" align="center" :label="$t('order.customer_name')" data-name="客户名称"></el-table-column>
				<el-table-column prop="user_info.email" align="center" :label="$t('order.email')" data-name="email"></el-table-column>

				<el-table-column prop="price" align="center" :label="$t('order.price')"></el-table-column>
				<el-table-column prop="use_score" align="center" :label="$t('order.score')"></el-table-column>
				<el-table-column prop="discount" align="center" :label="$t('order.discount')">
					<template slot-scope="scope">{{amount_jisuan(scope.row)}}</template>
				</el-table-column>
				<el-table-column prop="pay_price" align="center" :label="$t('order.total')"></el-table-column>
				<el-table-column prop="remarks" align="center" :label="$t('feedback_index.remarks')"></el-table-column>
				<el-table-column prop="confirmation" align="center" :label="$t('order.letter')">
					<template slot-scope="scope">{{scope.row.confirmation==1?'YES':'NO'}}</template>
				</el-table-column>
				<el-table-column prop="refund_amount" align="center" :label="$t('order.refund')"></el-table-column>
				<el-table-column prop="pay_method" align="center" :label="$t('order.payment')"></el-table-column>
				<el-table-column prop="referred_email" align="center" :label="$t('order.referred_email')"></el-table-column>
				<el-table-column align="center" :label="$t('order.classes_name')" data-name="常规课">
					<el-table-column align="center" :width="200+200+150+120+120+200+320+10" class-name="class_padding">
						<template slot="header">
							<table class="w100">
								<colgroup>
									<col width="200">
									<col width="200">
									<col width="150">
									<col width="120">
									<col width="120">
									<col width="200">
									<col width="80">
									<col width="80">
									<col width="80">
									<col width="80">
								</colgroup>
								<tr>
									<th class="th_center">{{$t('order.subject')}}</th>
									<th class="th_center">{{$t('order.children')}}</th>
									<th class="th_center">{{$t('order.teacher')}}</th>
									<th class="th_center">{{$t('order.date')}}</th>
									<th class="th_center">{{$t('order.time')}}</th>
									<th class="th_center">{{$t('order.on_date')}}</th>
									<th class="th_center">{{$t('order.price')}}</th>
									<th class="th_center">{{$t('order.discount')}}</th>
									<th class="th_center">{{$t('order.score')}}</th>
									<th class="th_center">{{$t('order.total')}}</th>
								</tr>
							</table>
						</template>
						<template slot-scope="{row}">
							<el-table :data="row.course_list" border size="mini" class="w100" :show-header="false">
								<el-table-column align="center" width="199" class-name="class_name" :prop="lang=='cn'?'name_cn':'name'"></el-table-column>
								<el-table-column align="center" width="199" class-name="class_name">
								  	<template slot-scope="{row}">
										<p v-for="(item,index) in row.children" :key="index">{{item.name}}:{{item.age}}y</p>
									</template>
								</el-table-column>
								<el-table-column align="center" width="149" class-name="class_name" :prop="lang=='cn'?'teacher.name_cn':'teacher.name'"></el-table-column>
								<el-table-column align="center" width="119" class-name="class_name">
								  	<template slot-scope="{row}">
									  	{{getTime_us(row.course_info.start_date,'mmddyyyy')}}-{{getTime_us(row.course_info.end_date,'mmddyyyy')}}
									</template>
								</el-table-column>
								<el-table-column align="center" width="119" class-name="class_name">
									<template slot-scope="{row}">
										{{getTime_us(row.course_info.start_time,'hh:ii')}}-{{getTime_us(row.course_info.end_time,'hh:ii')}}
									</template>
								</el-table-column>
								<el-table-column align="center" width="199" class-name="class_name">
									<template slot-scope="{row}">{{row.course_info.no_course_dates | no_course_dates_f(this_)}}</template>
								</el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="price"></el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="discounts_all">
								  	<template slot-scope="{row}">-{{row.discounts_all}}</template>
								</el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="score">
								  	<template slot-scope="{row}">-{{row.score}}</template>
								</el-table-column>
								<el-table-column align="center" width="" class-name="class_name" prop="pay_price"></el-table-column>
							</el-table>
						</template>
					</el-table-column>
				</el-table-column>

				<el-table-column align="center" :label="$t('order.camps')" data-name="夏令营">
					<el-table-column align="center" :width="200+200+150+120+120+200+320+10" class-name="class_padding">
						<template slot="header">
							<table>
								<colgroup>
									<col width="200">
									<col width="200">
									<col width="150">
									<col width="120">
									<col width="120">
									<col width="200">
									<col width="80">
									<col width="80">
									<col width="80">
									<col width="80">
								</colgroup>
								<tr>
									<th class="th_center">{{$t('order.subject')}}</th>
									<th class="th_center">{{$t('order.children')}}</th>
									<th class="th_center">{{$t('order.teacher')}}</th>
									<th class="th_center">{{$t('order.date')}}</th>
									<th class="th_center">{{$t('order.time')}}</th>
									<th class="th_center">{{$t('order.on_date')}}</th>
									<th class="th_center">{{$t('order.price')}}</th>
									<th class="th_center">{{$t('order.discount')}}</th>
									<th class="th_center">{{$t('order.score')}}</th>
									<th class="th_center">{{$t('order.total')}}</th>
								</tr>
							</table>
						</template>
						<template slot-scope="{row}">
							<el-table :data="row.camp_list" size="mini" border :show-header="false" class="w100">
								<el-table-column align="center" width="199" class-name="class_name" :prop="lang=='cn'?'name_cn':'name'"></el-table-column>
								<el-table-column align="center" width="199" class-name="class_name">
								  	<template slot-scope="{row}">
										<p v-for="(item,index) in row.children" :key="index">{{item.name}}:{{item.age}}y</p>
									</template>
								</el-table-column>
								<el-table-column align="center" width="149" class-name="class_name" :prop="lang=='cn'?'teacher_name_cn':'teacher_name'"></el-table-column>
								<el-table-column align="center" width="119" class-name="class_name">
								  	<template slot-scope="{row}">
								  		{{getTime_us(row.start_date_time,'mmddyyyy')}}-{{getTime_us(row.end_date_time,'mmddyyyy')}}
									</template>
								</el-table-column>
								<el-table-column align="center" width="119" class-name="class_name">
									<template slot-scope="{row}">
										{{getTime_us(row.start_time,'hh:ii')}}-{{getTime_us(row.end_time,'hh:ii')}}
									</template>
								</el-table-column>
								<el-table-column align="center" width="199" class-name="class_name">
									<template slot-scope="{row}">{{row.no_course_date | no_course_dates_f(this_)}}</template>
								</el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="price"></el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="discounts_all">
								  	<template slot-scope="{row}">-{{row.discounts_all}}</template>
								</el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="score">
								  	<template slot-scope="{row}">-{{row.score}}</template>
								</el-table-column>
								<el-table-column align="center" width="" class-name="class_name" prop="pay_price"></el-table-column>
							</el-table>
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column align="center" :label="$t('order.private')" data-name="私教课">
					<el-table-column align="center" :width="200+200+150+180+320+10" class-name="class_padding">
						<template slot="header">
							<table>
								<colgroup>
									<col width="200">
									<col width="200">
									<col width="150">
									<col width="180">
									<col width="80">
									<col width="80">
									<col width="80">
									<col width="80">
								</colgroup>
								<tr>
									<th class="th_center">{{$t('order.subject')}}</th>
									<th class="th_center">{{$t('order.children')}}</th>
									<th class="th_center">{{$t('order.teacher')}}</th>
									<th class="th_center">{{$t('order.time')}}</th>
									<th class="th_center">{{$t('order.price')}}</th>
									<th class="th_center">{{$t('order.discount')}}</th>
									<th class="th_center">{{$t('order.score')}}</th>
									<th class="th_center">{{$t('order.total')}}</th>
								</tr>
							</table>
						</template>
						<template slot-scope="{row}">
							<el-table :data="row.private_list" size="mini" :show-header="false" class="w100">
								<el-table-column align="center" width="199" class-name="class_name" :prop="lang=='cn'?'name_cn':'name'"></el-table-column>
								<el-table-column align="center" width="199" class-name="class_name">
								  	<template slot-scope="{row}">
										<p v-for="(item,index) in row.children" :key="index">{{item.name}}:{{item.age}}y</p>
									</template>
								</el-table-column>
								<el-table-column align="center" width="149" class-name="class_name" :prop="lang=='cn'?'teacher.name_cn':'teacher.name'"></el-table-column>
								<el-table-column align="center" width="179" class-name="class_name">
									<template slot-scope="{row}">
										{{getTime_us(row.start_time,'mmddyyyyampm')}}-{{getTime_us(row.end_time,'ampm')}}
									</template>
								</el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="price"></el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="discounts_all">
								  	<template slot-scope="{row}">-{{row.discounts_all}}</template>
								</el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="score">
								  	<template slot-scope="{row}">-{{row.score}}</template>
								</el-table-column>
								<el-table-column align="center" width="" class-name="class_name" prop="pay_price"></el-table-column>
							</el-table>
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column align="center" :label="$t('order.activity')" data-name="活动">
					<el-table-column align="center" :width="200+200+320+10" class-name="class_padding">
						<template slot="header">
							<table>
								<colgroup>
									<col width="200">
									<col width="200">
									<col width="80">
									<col width="80">
									<col width="80">
									<col width="80">
								</colgroup>
								<tr>
									<th class="th_center">{{$t('order.subject')}}</th>
									<th class="th_center">{{$t('order.children')}}</th>
									<th class="th_center">{{$t('order.price')}}</th>
									<th class="th_center">{{$t('order.discount')}}</th>
									<th class="th_center">{{$t('order.score')}}</th>
									<th class="th_center">{{$t('order.total')}}</th>
								</tr>
							</table>
						</template>
						<template slot-scope="{row}">
							<el-table :data="row.activity_list" size="mini" :show-header="false" class="w100">
								<el-table-column align="center" width="199" class-name="class_name" :prop="lang=='cn'?'name_cn':'name'"></el-table-column>
								<el-table-column align="center" width="199" class-name="class_name">
								  	<template slot-scope="{row}">
										<p v-for="(item,index) in row.children" :key="index">{{item.name}}:{{item.age}}y</p>
									</template>
								</el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="price"></el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="discounts_all">
								  	<template slot-scope="{row}">-{{row.discounts_all}}</template>
								</el-table-column>
								<el-table-column align="center" width="79" class-name="class_name" prop="score">
								  	<template slot-scope="{row}">-{{row.score}}</template>
								</el-table-column>
								<el-table-column align="center" width="" class-name="class_name" prop="pay_price"></el-table-column>
							</el-table>
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column prop="classes" align="center" :label="$t('index.operation')" width="100" fixed="right">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="order_info(scope.row.order_id)">{{$t('index.info')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="page-pagination">
				<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
			</div>
			<el-dialog :title="$t('index.info')" data-title="详情" append-to-body width="1200px" :close-on-click-modal="false" :visible.sync="editFormVisible" @close="editFormVisible = false">
				<div v-if="course_list.length">
					<div class="pp1">{{$t('order.classes_name')}}</div>
					<el-table :data="course_list" border size="mini">
					  <el-table-column align="center" :prop="lang=='cn'?'name_cn':'name'" :label="$t('order.name')" data-name="主题"  :key="4"></el-table-column>
					  <el-table-column prop="children_name" align="center" :label="$t('order.children')" data-name="学生"  :key="5">
						<template slot-scope="{row}">
							<p v-for="(item,index) in row.children" :key="index">{{item.name}}:{{item.age}}y</p>
						</template>
					  </el-table-column>
					  <el-table-column :prop="lang=='cn'?'teacher.name_cn':'teacher.name'" align="center" :label="$t('order.teacher')" data-name="老师"  :key="6"></el-table-column>
					  <el-table-column align="center" :label="$t('order.date')" data-name="日期"  :key="7">
						<template slot-scope="{row}">{{getTime_us(row.course_info.start_date,'mmddyyyy')}}-{{getTime_us(row.course_info.end_date,'mmddyyyy')}}</template>
					  </el-table-column>
					  <el-table-column align="center" :label="$t('order.time')" :key="8" data-name="时间">
						<template slot-scope="{row}">{{getTime_us(row.course_info.start_time,'hh:ii')}}-{{getTime_us(row.course_info.end_time,'hh:ii')}}</template>
					  </el-table-column>
					  <el-table-column align="center" :label="$t('order.on_date')" :key="9" data-name="不上课日期">
						<template slot-scope="{row}">{{row.course_info.no_course_dates | no_course_dates_f(this_)}}</template>
					  </el-table-column>
					  <el-table-column prop="price" :label="$t('order.price')" align="center" :key="10" data-name="不上课日期"></el-table-column>
					  <el-table-column prop="discounts_all" :label="$t('order.discount')" align="center" :key="11"></el-table-column>
					  <el-table-column prop="score" :label="$t('order.score')" align="center" :key="12"></el-table-column>
					  <el-table-column prop="pay_price" :label="$t('order.total')" align="center" :key="13"></el-table-column>
					  <el-table-column align="center" :label="$t('index.operation')" data="操作" :key="15">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua(scope.row)">{{$t('index.copy')}}</el-button>
						</template>
					  </el-table-column>
					</el-table>
				</div>
				<div v-if="camp_list.length">
					<div class="pp1">{{$t('order.camps')}}</div>
					<el-table :data="camp_list" border size="mini">
					  <el-table-column align="center" :prop="lang=='cn'?'theme_cn':'theme'" :label="$t('order.subject')" :key="4"></el-table-column>
					  <el-table-column prop="children_name" align="center" :label="$t('order.children')" :key="5">
						<template slot-scope="scope">
							<span v-for="(items,indexs) in scope.row.children" :key="indexs">{{items.name}}:{{items.age}}y</span>
						</template>
					  </el-table-column>
					  <el-table-column :prop="lang=='cn'?'teacher_name_cn':'teacher_name'" align="center" :label="$t('order.teacher')" :key="6"></el-table-column>
					  <el-table-column align="center" :label="$t('order.date')" :key="7">
						<template slot-scope="scope">{{getTime_us(scope.row.start_date_time,'mmddyyyy')}}-{{getTime_us(scope.row.end_date_time,'mmddyyyy')}}</template>
					  </el-table-column>
					  <el-table-column align="center" :label="$t('order.time')" :key="8">
						<template slot-scope="scope">{{getTime_us(scope.row.start_time,'hh:ii')}}-{{getTime_us(scope.row.end_time,'hh:ii')}}</template>
					  </el-table-column>
					  <el-table-column align="center" :label="$t('order.on_date')" :key="9">
						<template slot-scope="scope">{{scope.row.no_course_date | no_course_dates_f(this_)}}</template>
					  </el-table-column>
					  <el-table-column prop="price" :label="$t('order.price')" align="center" :key="10"></el-table-column>
					  <el-table-column prop="discounts_all" :label="$t('order.discount')" align="center" :key="11">
					  	<template slot-scope="scope">-{{scope.row.discounts_all}}</template>
					  </el-table-column>
					  <el-table-column prop="score" :label="$t('order.score')" align="center" :key="12">
					  	<template slot-scope="scope">-{{scope.row.score}}</template>
					  </el-table-column>
					  <el-table-column prop="pay_price" :label="$t('order.total')" align="center" :key="13"></el-table-column>
					  <el-table-column align="center" :label="$t('index.operation')" data="操作">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua_xalingy(scope.row)">{{$t('index.copy')}}</el-button>
						</template>
					  </el-table-column>
					</el-table>
				</div>
				<div v-if="private_list.length">
					<div class="pp1">{{$t('order.private')}}</div>
					<el-table :data="private_list" border size="mini">
					  <el-table-column align="center" :prop="lang=='cn'?'name_cn':'name'" :label="$t('order.subject')" :key="6"></el-table-column>
					  <el-table-column prop="children_name" align="center" :label="$t('order.children')" :key="7">
						<template slot-scope="scope">
							<span v-for="(items,indexs) in scope.row.children" :key="indexs">{{items.name}}{{items.age}}y</span>
						</template>
					  </el-table-column>
					  <el-table-column :prop="lang=='cn'?'teacher.name_cn':'teacher.name'" align="center" :label="$t('order.teacher')" :key="8"></el-table-column>
					  <el-table-column align="center" :label="$t('order.time')" :key="9">
						<template slot-scope="scope">
							<p>{{getTime_us(scope.row.start_time,'mmddyyyy')}} ~ {{getTime_us(scope.row.end_time,'mmddyyyy')}}</p>
							<p>{{getTime_us(scope.row.start_time,'hh:ii')}} ~ {{getTime_us(scope.row.end_time,'hh:ii')}}</p>
							<!-- {{getTime_us(scope.row.start_time,'mmddyyyyampm')}}-{{getTime_us(scope.row.end_time,'ampm')}} -->
						</template>
					  </el-table-column>
					  <el-table-column prop="price" :label="$t('order.price')" align="center" :key="10"></el-table-column>
					  <el-table-column prop="discounts_all" :label="$t('order.discount')" align="center" :key="11">
					  	<template slot-scope="scope">-{{scope.row.discounts_all}}</template>
					  </el-table-column>
					  <el-table-column prop="score" :label="$t('order.score')" align="center" :key="12">
					  	<template slot-scope="scope">-{{scope.row.score}}</template>
					  </el-table-column>
					  <el-table-column prop="pay_price" :label="$t('order.total')" align="center" :key="13"></el-table-column>
					  <el-table-column align="center" :label="$t('index.operation')" data="操作">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua_sijiaok(scope.row)">{{$t('index.copy')}}</el-button>
						</template>
					  </el-table-column>
					</el-table>
				</div>
				<div v-if="activity_list.length">
					<div class="pp1">{{$t('order.activity')}}</div>
					<el-table :data="activity_list" border size="mini">
					  <el-table-column align="center" :prop="lang=='cn'?'name_cn':'name'" :label="$t('order.subject')" :key="8"></el-table-column>
					  <el-table-column prop="children_name" align="center" :label="$t('order.children')" :key="9">
						<template slot-scope="scope">
							<span v-for="(items,indexs) in scope.row.children" :key="indexs">{{items.name}}{{items.age}}y</span>
						</template>
					  </el-table-column>
					  <el-table-column prop="price" :label="$t('order.price')" align="center" :key="10"></el-table-column>
					  <el-table-column prop="discounts_all" :label="$t('order.discount')" align="center" :key="11">
					  	<template slot-scope="scope">-{{scope.row.discounts_all}}</template>
					  </el-table-column>
					  <el-table-column prop="score" :label="$t('order.score')" align="center" :key="12">
					  	<template slot-scope="scope">-{{scope.row.score}}</template>
					  </el-table-column>
					  <el-table-column prop="pay_price" :label="$t('order.total')" align="center" :key="13"></el-table-column>
					  <el-table-column align="center" :label="$t('index.operation')" data="操作">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua_activity(scope.row)">{{$t('index.copy')}}</el-button>
						</template>
					  </el-table-column>
					</el-table>
				</div>
			</el-dialog>
		</el-dialog>
	</div>
</template>
<script>
import Clipboard from 'clipboard'; 
export default {
	props: {
		email:{
			type: String,
			default:''
		},
	},
	data() {
		return {
			this_:this,
			isdialog:false,
			list: [],
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
			editFormVisible:false,
			course_list:[],
			camp_list:[],
			private_list:[],
			activity_list:[],
		}
	},
	watch: {
		email(v){
			if (v) {
				this.init();
			}else{
				this.isdialog=false
			}
		},
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "orderDetailList";
			var datas = {
				email: this_.email,
				page:this_.pages.page,
				num:this_.pages.perpage,

			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
				this_.isdialog=true;
			})
		},
		order_info(order_id){
			var this_ = this;
			var url = "orderInfo";
			var datas = {
				order_id:order_id,
			};
			this_.$post(url, datas).then((res) => {
				this_.course_list = res.course_list||[];
				this_.camp_list = res.camp_list||{};
				this_.private_list = res.private_list||{};
				this_.activity_list = res.activity_list||[];
				this_.editFormVisible=true;
			})
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		guanbitanchu(){
			this.list=[];
			this.$emit("guanbi");
		},
		// 优惠金额
		amount_jisuan(data){
			var discounts=data.discounts?parseFloat(data.discounts):0;
			var coupon_price=data.coupon_price?parseFloat(data.coupon_price):0; 
			var yaoqing_price=data.yaoqing_price?parseFloat(data.yaoqing_price):0;
			var zhekou=data.zhekou?parseFloat(data.zhekou):0;
			// var use_score=data.use_score?parseFloat(data.use_score):0;
			var zhi= discounts+coupon_price+yaoqing_price+zhekou;
			return zhi.toFixed(2);
		},
		// 复制
		copy(){
			var this_ = this;
			var clipboard = new Clipboard('.tag-read');
			clipboard.on('success', e => {
				this_.$message.success(this_.$t('index.copy_success'));
				clipboard.destroy()
			})
			clipboard.on('error', e => {
				this_.$message.success(this_.$t('index.copy_error'));
				clipboard.destroy()
			})
		},
		geshihua(data){
			var name="#"+data.order_id+' '+(this.getTime_us(data.course_info.start_date,'mmdd'))+'-'+(this.getTime_us(data.course_info.end_date,'mmdd'))+','+(this.getTime_us(data.course_info.start_time,'ampm'))+'-'+(this.getTime_us(data.course_info.end_time,'ampm'))+','+(this.lang=='cn'?data.teacher.name_cn:data.teacher.name)+','+(this.lang=='cn'?data.name_cn:data.name);
			return name;
		},
		geshihua_xalingy(data,camp_list){
			var name="#"+data.transaction_id+' '+(this.getTime_us(data.start_date_time,'mmdd'))+'-'+(this.getTime_us(data.end_date_time,'mmdd'))+','+(this.getTime_us(data.start_time,'ampm'))+'-'+(this.getTime_us(data.end_time,'ampm'))+','+(this.lang=='cn'?data.teacher_name_cn:data.teacher_name)+','+(this.lang=='cn'?data.theme_cn:data.theme);
			return name;
		},
		geshihua_sijiaok(data,camp_list){
			var name="#"+data.order_id+' '+(this.getTime_us(data.start_time,'mmddyyyyampm'))+'-'+(this.getTime_us(data.end_time,'ampm'))+','+(this.lang=='cn'?data.teacher.name_cn:data.teacher.name)+','+(this.lang=='cn'?data.name_cn:data.name);
			return name;
		},
		geshihua_activity(data,camp_list){
			var name="#"+data.order_id+','+(this.lang=='cn'?data.name_cn:data.name);
			return name;
		},
	},
	// 过滤器
	filters: {
		no_course_dates_f(v,this_){
			if (v) {
				var array=v.split(',');
				var zhi=[];
				array.forEach(function(e,i) {
					if (e) {
						zhi[i]=this_.getTime_us(e,'mmdd');
					}
				});
				return zhi.join(',');
			}else{
				return ' ';
			}
		},

	}
}
</script>
<style scoped>
.html_br a{
	display: inline;
}
.pp1{
	text-align: center;
	line-height: 40px;
	margin-top: 10px;
}
</style>
<style>
.class_name{
/* 	border-right: none!important; */
/* 	border-bottom: none!important; */
}
.class_padding .cell,
.class_padding{
/* 	padding: 0!important; */
}
.th_center{
	text-align: center!important;
}
</style>



// WEBPACK FOOTER //
// src/components/order_list.vue